"use client";

import React from "react";
import { toast as sonnerToast } from "sonner";
import Typography from "@/components/shared/Typography";
import Button from "@/components/ui/Button";
import Card from "@/components/ui/Card";
import { URLS } from "@/lib/consts";
import type { ToastProps } from "./types";

/** The actual toast UI using your custom components */
function CustomToast({ id, title, description, action }: ToastProps) {
  return (
    <Card
      items="center"
      variant="secondary"
      className="w-full border shadow-lg md:max-w-sm border-muted"
    >
      <Typography.Small className="text-lg font-bold text-white">
        {title}
      </Typography.Small>

      <Typography.Small className="text-sm text-white">
        {description}
      </Typography.Small>

      {action && (
        <Button.Icon
          label={action.label}
          variant="default"
          href={URLS.CONTACT_US}
          onClick={() => {
            action.onClick();
            sonnerToast.dismiss(id);
          }}
          aria-label="Goto contact us page"
        />
      )}
    </Card>
  );
}

/** General toast function that handles different toast types */
function toast(t: Omit<ToastProps, "id">) {
  return sonnerToast.custom(id => (
    <CustomToast
      id={id.toString()}
      title={t.title}
      description={t.description}
      action={t.action}
    />
  ));
}

/** Engagement toast with predefined styling & structure */
export function engagementToast({
  title = "Like What You See?",
  description = `Let's talk about building something amazing together.`,
  action = {
    label: "Get in Touch",
    onClick: () => null,
  },
}: Partial<ToastProps>) {
  return toast({ title, description, action, duration: 10000 });
}

export default toast;
